// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable usage; migrate off when touched
import { Map } from 'immutable';

export const ADD_TOAST = 'ADD_TOAST';
export function addToast(toast) {
  return {
    type: ADD_TOAST,
    toast: Map(toast),
  };
}

export const REMOVE_TOASTS = 'REMOVE_TOASTS';
export function removeToasts(toasts) {
  return {
    type: REMOVE_TOASTS,
    toasts,
  };
}
